module.exports = __webpack_public_path__ + "static/img_emergency_process_01@2x-97ce044dd14d9cff0414de7586e3d85e.png";